import { createContext, useContext, useState, useCallback } from "react";

const HI = {
    // Hero / Home
    "Your Home,": "आपका घर,",
    "Managed.": "संभाला हुआ।",
    "Trusted home services with clear pricing, verified professionals and support when you need it.":
        "भरोसेमंद होम सर्विस — साफ़ कीमत, वेरिफाइड प्रोफेशनल और ज़रूरत पर सहायता।",
    "BOOK A SERVICE": "सर्विस बुक करें",
    "What do you need today?": "आज आपको क्या चाहिए?",
    "Materials and additional work are charged": "सामग्री और अतिरिक्त काम का शुल्क",
    "only after your approval.": "केवल आपकी मंज़ूरी के बाद लिया जाता है।",
    "Why HOMIIE?": "HOMIIE क्यों?",
    "Need help with your home?": "अपने घर के लिए मदद चाहिए?",
    "Book a verified professional in under a minute.": "एक मिनट में वेरिफाइड प्रोफेशनल बुक करें।",
    "Verified Professionals": "वेरिफाइड प्रोफेशनल",
    "Background-checked, trained experts": "जाँचे-परखे, प्रशिक्षित विशेषज्ञ",
    "Clear Pricing": "साफ़ कीमत",
    "Visit fee shown upfront, no surprises": "विज़िट फीस पहले से दिखती है, कोई छुपा शुल्क नहीं",
    "Customer Approval": "ग्राहक की मंज़ूरी",
    "Work starts only after you approve": "काम आपकी मंज़ूरी के बाद ही शुरू होता है",
    "Digital Invoice": "डिजिटल इनवॉइस",
    "Every job gets a proper bill": "हर काम का सही बिल मिलता है",
    "CareBack Support": "केयरबैक सपोर्ट",
    "7-day workmanship protection": "7-दिन वर्कमैनशिप सुरक्षा",
    // Services
    "Electrician": "इलेक्ट्रीशियन",
    "Plumber": "प्लंबर",
    "AC Service": "एसी सर्विस",
    // Bottom nav
    "Home": "होम",
    "Bookings": "बुकिंग",
    "My Home": "मेरा घर",
    "Profile": "प्रोफ़ाइल",
    // Profile
    "Account": "अकाउंट",
    "Customer ID": "ग्राहक आईडी",
    "Mobile": "मोबाइल",
    "Email": "ईमेल",
    "Notifications": "सूचनाएँ",
    "No notifications yet.": "अभी कोई सूचना नहीं।",
    "WhatsApp Support": "व्हाट्सऐप सहायता",
    "Chat with the HOMIIE team": "HOMIIE टीम से चैट करें",
    "LOG OUT": "लॉग आउट",
    // Booking flow
    "Select a service": "सर्विस चुनें",
    "What's the problem?": "समस्या क्या है?",
    "Your details": "आपकी जानकारी",
    "Review & confirm": "समीक्षा और पुष्टि",
    "CONTINUE": "आगे बढ़ें",
    "CONFIRM BOOKING": "बुकिंग पक्की करें",
    "Booking Confirmed!": "बुकिंग पक्की हो गई!",
    "TRACK BOOKING": "बुकिंग ट्रैक करें",
    "Back to Home": "होम पर वापस",
    "Estimated starting price": "अनुमानित शुरुआती कीमत",
    // Bookings list
    "My Bookings": "मेरी बुकिंग",
    "Track all your home service requests": "अपनी सभी होम सर्विस रिक्वेस्ट देखें",
    "No bookings yet": "अभी कोई बुकिंग नहीं",
    "Book a Service": "सर्विस बुक करें",
    // Login/Register
    "Welcome back": "वापसी पर स्वागत है",
    "Log in to manage your home services.": "अपनी होम सर्विस मैनेज करने के लिए लॉग इन करें।",
    "LOG IN": "लॉग इन",
    "Phone number or email": "फ़ोन नंबर या ईमेल",
    "Password": "पासवर्ड",
    "Create account": "खाता बनाएँ",
    // My Home / Passport
    "Your homes, service history & team": "आपके घर, सर्विस इतिहास और टीम",
    "My HOMIIE Team": "मेरी HOMIIE टीम",
    "Your preferred professionals": "आपके पसंदीदा प्रोफेशनल",
    "Home Passport": "होम पासपोर्ट",
    "Service history": "सर्विस इतिहास",
    "Add item": "आइटम जोड़ें",
    "BOOK AGAIN": "फिर से बुक करें",
    "Language": "भाषा",
    // Bookings
    "Track all your home service requests": "अपनी सभी होम सर्विस रिक्वेस्ट ट्रैक करें",
    "Book your first home service in under a minute.": "एक मिनट में अपनी पहली होम सर्विस बुक करें।",
    "Approval needed": "मंज़ूरी ज़रूरी",
    "services": "सर्विसेज़",
    // Register
    "Create your account": "अपना खाता बनाएँ",
    "Join HOMIIE and manage your home with ease.": "HOMIIE से जुड़ें और अपने घर को आसानी से संभालें।",
    "Full name": "पूरा नाम",
    "Mobile number": "मोबाइल नंबर",
    "Password": "पासवर्ड",
    "Email (optional)": "ईमेल (वैकल्पिक)",
    "Referral / Pro code (optional)": "रेफ़रल / प्रो कोड (वैकल्पिक)",
    "CREATE ACCOUNT": "खाता बनाएँ",
    "Already have an account?": "पहले से खाता है?",
    "Log in": "लॉग इन",
    // Login
    "New to HOMIIE?": "HOMIIE पर नए हैं?",
    "Demo logins — tap to fill": "डेमो लॉगिन — भरने के लिए टैप करें",
    "Back to home": "होम पर वापस",
    "Become a HOMIIE Professional": "HOMIIE प्रोफेशनल बनें",
    "Join as a HOMIIE Professional": "HOMIIE प्रोफेशनल के रूप में जुड़ें",
    "Earn with verified, steady jobs near you": "अपने पास भरोसेमंद, नियमित काम से कमाएँ",
    // Profile
    "My Service Requests": "मेरी सर्विस रिक्वेस्ट",
    "Coming-soon services you've requested": "आपके द्वारा मांगी गई आने वाली सर्विसेज़",
    "Your Home, Managed.": "आपका घर, संभाला हुआ।",
    "Legal & Policies": "कानूनी और नीतियाँ",
    "Offers for You": "आपके लिए ऑफ़र",
    "Popular Services": "लोकप्रिय सेवाएँ",
    "Categories": "श्रेणियाँ",
    "See All": "सभी देखें",
    "Home Services": "होम सर्विसेज़",
    "Payments": "भुगतान",
    "Your payments & invoices": "आपके भुगतान और इनवॉइस",
    "No payments yet": "अभी कोई भुगतान नहीं",
    "Your payment history will appear here.": "आपका भुगतान इतिहास यहाँ दिखेगा।",
    "Terms, Privacy, Payment, Refund & CareBack": "शर्तें, प्राइवेसी, भुगतान, रिफंड और केयरबैक",
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("homiie_lang") || "en");
    const toggle = useCallback(() => {
        setLang((l) => {
            const next = l === "en" ? "hi" : "en";
            localStorage.setItem("homiie_lang", next);
            return next;
        });
    }, []);
    const t = useCallback((s) => (lang === "hi" ? HI[s] || s : s), [lang]);
    return (
        <LanguageContext.Provider value={{ lang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLang = () => useContext(LanguageContext);
